<template>
  <div class="xmcbhs-container" id="xmcbjs">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="listQuery" :inline="true">
        <el-form-item label="部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 130px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域总监" prop="xmbh">
          <el-select
            ref="areaDirector"
            v-model="listQuery.areaDirector"
            placeholder="区域总监"
            clearable
            filterable
            size="small"
            style="width: 130px"
            class="filter-item"
            :multiple="true"
            collapse-tags
            @change="handleChangeQyzj"
          >
            <el-option
              v-for="item in areaDirectorList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目类型" prop="htlx">
          <el-select
            ref="htlx"
            v-model="listQuery.htlx"
            placeholder="项目类型"
            clearable
            filterable
            size="small"
            style="width: 180px"
            class="filter-item"
            collapse-tags
          >
            <el-option
              v-for="item in htlx"
              :key="item.htlx"
              :label="item.htlxxmc"
              :value="item.htlx"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="项目名称"
            clearable
            filterable
            size="small"
            style="width: 270px"
            class="filter-item"
            :multiple="true"
            collapse-tags
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmmc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="统计周期" prop="status">
          <!-- <el-date-picker
            v-model="time"
            type="daterange"
            size="small"
            style="width: 220px"
            :clearable="false"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @keyup.enter.native="getList"
            format="yyyy-MM-dd"
            @change="handleChangeTime"
            :pickerOptions="pickerOptions"
          ></el-date-picker> -->
          <el-date-picker
            v-model="time[0]"
            style="width: 150px"
            type="date"
            placeholder="开始日期"
            :pickerOptions="pickerOptions"
            @change="onStartChange"
          >
          </el-date-picker>
          &nbsp; &nbsp;- &nbsp; &nbsp;
          <el-date-picker
            v-model="time[1]"
            style="width: 150px"
            type="date"
            placeholder="结束日期"
            :pickerOptions="pickerOptions"
            @change="onEndChange"
          >
          </el-date-picker>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div class="mycontainer">
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        :cell-class-name="myclass"
        ref="xmcbhsTable"
      >
        <el-table-column label="操作" align="left" min-width="60px" fixed>
          <template slot-scope="scope">
            <div>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-plus"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="分公司"
          prop="bmmc"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目名称"
          prop="xmmc"
          min-width="100px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmmc }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="合同起止时间"
          prop="htzq"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.htzq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="区域总监"
          prop="areaDirector"
          :show-overflow-tooltip="true"
          min-width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.areaDirector }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="质量分类"
          prop="qualitysort"
          min-width="80px"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.qualitysort }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预算工作量（人/日）"
          prop="gzlys"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gzlys }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="维秘工作量（人/日）"
          prop="wmgzl"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.wmgzl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预算成本(元)"
          prop="xmys"
          min-width="120px"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ formatWithMod("" + scope.row.xmys) }}
          </template>
        </el-table-column>
        <el-table-column
          label="预算所属周期"
          prop="yssszq"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.yssszq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目回款(元)"
          prop="money"
          min-width="120px"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toHkDetail(scope.row)">{{
              formatWithMod("" + scope.row.money)
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="决算成本（元）"
          prop="xmjscb"
          min-width="120px"
          align="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row)">{{
              formatWithMod("" + scope.row.xmjscb)
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="实际利润率（%）"
          prop="sjlrl"
          min-width="140px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sjlrl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="预算利润率（%）"
          prop="yslrl"
          min-width="140px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.yslrl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="对比偏差值"
          prop="dbpcz"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.dbpcz }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="对比偏差率（%）"
          prop="dbpcl"
          min-width="140px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.dbpcl }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑"
      :visible.sync="dialogFlag"
      width="800px"
    >
      <el-form
        ref="rules"
        :model="editData"
        :rules="rules"
        label-width="100px"
        id="save-form"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目名称:" prop="xmmc">
              <el-input v-model="editData.xmmc" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="区域总监:" prop="areadirector">
              <el-input v-model="editData.areadirector" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="预算所属周期:" prop="halfYearIndex">
              <el-radio-group
                v-model="editData.halfYearIndex"
                @change="handleChangehalfYear"
              >
                <el-radio :label="0">上半年</el-radio>
                <el-radio :label="1">下半年</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目预算(元):" prop="xmys">
              <el-input-number
                v-model="editData.xmys"
                :precision="2"
                :min="0"
                :max="100000000"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="预算总工作量(人/日):" prop="gzlys">
              <el-input-number
                v-model="editData.gzlys"
                :precision="2"
                :min="0"
                :max="10000"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="saveCbys()"
          style="margin-right: 15px"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogFlag = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="项目决算成本明细"
      :visible.sync="dialogFlag2"
      width="90%"
      v-if="dialogFlag2"
      id="mx-dialog"
    >
      <Xmcbjsmx :mxParams="mxParams"></Xmcbjsmx>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="项目回款明细"
      :visible.sync="dialogFlag3"
      width="90%"
      v-if="dialogFlag3"
      id="hkmx-dialog"
    >
      <Xmhkmx :mxParams="mxParams"></Xmhkmx>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { formatMomentDate, deepClone } from "@/utils/utils";
import Xmcbjsmx from "./xmcbjsmx.vue";
import Xmhkmx from "./xmhkmx.vue";
import {
  getXmcbhsList,
  getCbhs,
  saveCbhs,
  getAreaDirector,
  getBmxx,
  getXmxx,
  isAreaDirector,
  xmcbhsExport,
  getHtlx,
} from "@/api/xmcbhs.js";
import moment from "moment";
import "moment/locale/zh-cn";

export default {
  name: "xmcbhs",
  components: { Pagination, Xmcbjsmx, Xmhkmx },
  data() {
    return {
      height: 115,
      listQuery: {
        xmbh: [],
        bmbh: "",
        qsrq: moment().format("YYYYMM") + "01",
        jsrq: moment().format("YYYYMMDD"),
        areaDirector: [],
        htlx: "",
        page: 1,
        pageSize: 10,
      },
      mxParams: {
        //项目成本核算明细 搜索参数
        xmbh: "",
        bmbh: "",
        time: [],
      },
      total: 0,
      bmList: [],
      xmList: [],
      areaDirectorList: [],
      time: [this.getCurrentMonthFirst(), Date.now()],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      list: [],
      listLoading: true,
      dialogFlag: false,
      dialogFlag2: false,
      dialogFlag3: false,
      editData: {
        halfYearIndex: 0,
        halfYearParam: [
          {
            qsrq: moment().format("YYYY") + "0101",
            jsrq: moment().format("YYYY") + "0630",
          },
          {
            qsrq: moment().format("YYYY") + "0701",
            jsrq: moment().format("YYYY") + "1231",
          },
        ],
      },
      rules: {
        xmys: [
          { required: true, message: "项目预算不能为空！", trigger: "blur" },
        ],
        gzlys: [
          {
            required: true,
            message: "预算总工作量不能为空！",
            trigger: "blur",
          },
        ],
      },
      halfYear2: [], //下半年
      htlx: [],
    };
  },
  created() {
    // login().then((res) => {
    //   localStorage.setItem("token", res.token);

    getHtlx().then((res) => {
      if (res.code == 0) {
        this.htlx = res.data;
      }
    });
    isAreaDirector().then((res) => {
      if (res.code == 0) {
        if (res.data && res.data != "null") {
          this.listQuery.areaDirector.push(res.data);
        }
        getBmxx().then((res2) => {
          if (res2.code == 0) {
            this.bmList = res2.data;
            if (this.bmList && this.bmList.length > 1) {
              this.bmList.unshift({ bmbh: "", bmmc: "全部" });
            }
            this.listQuery.bmbh = this.bmList[0].bmbh;
            getAreaDirector(this.listQuery.bmbh).then((res3) => {
              if (res3.code == 0) {
                this.areaDirectorList = res3.data;
                const qyzj = this.listQuery.areaDirector.join(",");
                getXmxx(this.listQuery.bmbh, qyzj).then((res4) => {
                  if (res4.code == 0) {
                    this.xmList = res4.data;
                    this.getList();
                  }
                });
              }
            });
          }
        });
      }
      // });
    });
  },
  methods: {
    onStartChange(start) {
      // 开始日期晚于结束日期时，结束日期自动设置为开始日期
      const isAfter = moment(start).isAfter(this.time[1]);
      if (isAfter) {
        this.$set(this.time, 1, start);
      }
    },
    onEndChange(end) {
      // 结束日期早于开始日期时，开始日期自动设置为结束日期
      const isBefore = moment(end).isBefore(this.time[0]);
      if (isBefore) {
        // 赋值需要回显,需使用一下写法
        this.$set(this.time, 0, end);
        //错误写法
        // this.time[0] = end;
        // 语法
        // this.$set(原数组, 索引值, 需要赋的值);
      }
    },
    //月份第一天时间戳
    getCurrentMonthFirst() {
      var date = new Date();
      date.setDate(1);
      return date;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    getList() {
      if (this.time && this.time.length == 2) {
        this.listQuery.qsrq = formatMomentDate(new Date(this.time[0]));
        this.listQuery.jsrq = formatMomentDate(new Date(this.time[1]));
        if (
          this.listQuery.qsrq.slice(0, 4) != this.listQuery.jsrq.slice(0, 4)
        ) {
          this.$message.error("查询的统计周期不能跨年，请重新选择！");
          return;
        }
      }
      this.listLoading = true;
      getXmcbhsList(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.$nextTick(() => {
            this.listLoading = false;
            this.list = res.data;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 95;
            this.total = res.count;
            this.$nextTick(() => {
              this.$refs.xmcbhsTable.bodyWrapper.scrollTop = 0;
            });
          });
        }
      });
    },
    handleChangeTime(e) {},
    handleChangeBm(e) {
      // 部门
      this.listQuery.bmbh = e;
      this.listQuery.xmbh = [];
      this.listQuery.areaDirector = [];
      getAreaDirector(this.listQuery.bmbh).then((res3) => {
        if (res3.code == 0) {
          this.areaDirectorList = res3.data;
          getXmxx(this.listQuery.bmbh, "").then((res4) => {
            if (res4.code == 0) {
              this.xmList = res4.data;
            }
          });
        }
      });
    },
    handleChangeQyzj(e) {
      //区域总监select框
      const qyzj = e.join(",");
      this.listQuery.xmbh = [];
      getXmxx(this.listQuery.bmbh, qyzj).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },
    handleEdit(row) {
      this.dialogFlag = true;
      if (+moment().format("MM") > 6) {
        this.editData.halfYearIndex = 1;
      } else {
        this.editData.halfYearIndex = 0;
      }
      const qsrq =
        this.editData.halfYearParam[this.editData.halfYearIndex].qsrq;
      const jsrq =
        this.editData.halfYearParam[this.editData.halfYearIndex].jsrq;
      this.getEditData(row.xmbh, qsrq, jsrq);
    },
    getEditData(xmbh, ysqsrq, ysjsrq) {
      getCbhs({ xmbh, ysqsrq, ysjsrq }).then((res) => {
        if (res.code == 0) {
          this.editData = { ...this.editData, ...res.data };
          if (!res.data.xmys) {
            this.editData.xmys = 0;
          }
          if (!res.data.gzlys) {
            this.editData.gzlys = 0;
          }
        }
      });
    },
    handleChangehalfYear(e) {
      const index = Number(e);
      const xmbh = this.editData.xmbh;
      const qsrq = this.editData.halfYearParam[index].qsrq;
      const jsrq = this.editData.halfYearParam[index].jsrq;
      this.getEditData(xmbh, qsrq, jsrq);
    },
    saveCbys() {
      const index = this.editData.halfYearIndex;
      const params = {
        xmbh: this.editData.xmbh,
        xmys: this.editData.xmys,
        gzlys: this.editData.gzlys,
        ysqsrq: this.editData.halfYearParam[index].qsrq,
        ysjsrq: this.editData.halfYearParam[index].jsrq,
      };
      saveCbhs(params).then((res) => {
        if (res.code == 0) {
          this.dialogFlag = false;
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toDetail(row) {
      // this.$store.dispatch("xmcbhs/setXmcbhsParams", {
      //   xmbh: this.listQuery.xmbh,
      //   bmbh: this.listQuery.bmbh,
      // });
      this.mxParams = {
        bmbh: row.bmbh,
        xmbh: row.xmbh,
        time: this.time,
      };
      this.dialogFlag2 = true;
    },
    toHkDetail(row) {
      // this.$store.dispatch("xmcbhs/setXmcbhsParams", {
      //   xmbh: this.listQuery.xmbh,
      //   bmbh: this.listQuery.bmbh,
      // });
      this.mxParams = {
        bmbh: row.bmbh,
        xmbh: row.xmbh,
        time: this.time,
      };
      this.dialogFlag3 = true;
    },
    //导出
    handleExport() {
      const params = deepClone(this.listQuery);
      if (params.areaDirector instanceof Array) {
        params.areaDirector = params.areaDirector.join(",");
      }
      if (params.xmbh instanceof Array) {
        params.xmbh = params.xmbh.join(",");
      }
      xmcbhsExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    myclass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 12) {
        if (row.sjlrl < 0) {
          return "red";
        }
      }
      if (columnIndex == 13) {
        if (row.yslrl < 0) {
          return "red";
        }
      }
      if (columnIndex == 14) {
        if (row.dbpcz > 0) {
          return "red";
        }
      }
      if (columnIndex == 15) {
        if (row.dbpcl > 0) {
          return "red";
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.xmcbhs-container {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 160px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 160px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
::v-deep #xmcbjs .el-input__inner {
  height: 32px !important;
  line-height: 32px;
}
</style>
